import * as React from "react";
import "./UserCard.scss";
import { IRoleModel, IUserInfo } from "../../models/IUserInfo";
import { formatOrganisationNumber } from "../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { isInRole } from "../../contexts/UserContext";
import { MENUETTPORTALMA } from "../../utils/RoleConstants";

interface IUserCard {
    userInfo: IUserInfo;
}

export const UserCard: React.FunctionComponent<IUserCard> = ({  userInfo }) => {
    const hasRoleMA = isInRole(MENUETTPORTALMA, userInfo.roles ? userInfo.roles : []);

    const myWindow: any = window;
    const rolesToolTipId = "roles-tooltip";
    const clinicsToolTipId = "clinics-tooltip";
    const municipalityToolTipId = "municipality-tooltip";

    React.useEffect(() => {
        myWindow.$(`#${rolesToolTipId}`).tooltip();
    }, [userInfo.roles]);

    React.useEffect(() => {
        myWindow.$(`#${clinicsToolTipId}`).tooltip();
    }, [userInfo.organisationName]);

    React.useEffect(() => {
        myWindow.$(`#${municipalityToolTipId}`).tooltip();
    }, [userInfo.municipalityName])

    const roleTooltip = (): string => {
        let tooltip = [];
        if (userInfo.roles) {
            tooltip.push(`<strong>Roller:</strong>`)
            for (const role of userInfo.roles) {
                tooltip.push(`<p>${role.description}</p>`);
            }
        }
        return tooltip.join('');
    }

    const clinicTooltip = (): string => {
        let tooltip = [];
        if (userInfo.roles) {
            tooltip.push(`<p><strong>Vårdgivare:</strong><br /> ${userInfo.organisationName}</p>`);
            tooltip.push(`<p>Organisationsnummer:<br /> ${formatOrganisationNumber(userInfo.organisationNumber)}</p>`);

            if (hasRoleMA) {
                tooltip.push(`<p><strong>Mottagning:</strong><br /> ${userInfo.clinicName}</p>`);
                tooltip.push(`<p>Mottagningsnummer:<br /> ${userInfo.clinicNumber}</p>`);
            }
        }
        return tooltip.join('');
    }

    const municipalityTooltip = (): string => {
        let tooltip = [];
        if (userInfo.roles) {
            tooltip.push(`<p><strong>Kommun:</strong><br /> ${userInfo.municipalityName}</p>`);
            if (userInfo.districtName) {
                tooltip.push(`<p><strong>Stadsdel:</strong><br /> ${userInfo.districtName}</p>`);
            }
        }
        return tooltip.join('');
    }

    const onUserCardMouseOverRoles = () => {
        myWindow.$(`#${rolesToolTipId}`).tooltip("enable");
        myWindow.$(`#${rolesToolTipId}`).tooltip("show");
    }

    const onUserCardMouseOverClinic = () => {
        myWindow.$(`#${clinicsToolTipId}`).tooltip("enable");
        myWindow.$(`#${clinicsToolTipId}`).tooltip("show");
    }

    const onUserCardMouseOverMunicipality = () => {
        myWindow.$(`#${municipalityToolTipId}`).tooltip("enable");
        myWindow.$(`#${municipalityToolTipId}`).tooltip("show");
    }

    const getMunicipalityDistrictName = () => {
        if (userInfo) {
            if (userInfo.districtName) {
                return `${userInfo.municipalityName}/${userInfo.districtName}`;
            } else {
                return userInfo.municipalityName;
            }
        }
        return "";
    }

    return (
        <div className="user-card text-right">
            <h3>Menuett Portal</h3>
            <p className="text signed-in">Inloggad:</p>
            <p className="text user" id={rolesToolTipId} data-toggle="tooltip" data-html="true" data-original-title={roleTooltip()} onMouseOver={() => onUserCardMouseOverRoles()}>
                {userInfo.username}
            </p> -
            {
                userInfo.municipalityName ?
                    <>
                        <p className="text clinic" id={municipalityToolTipId} data-toggle="tooltip" data-html="true" data-original-title={municipalityTooltip()} onMouseOver={() => onUserCardMouseOverMunicipality()}>
                            {getMunicipalityDistrictName()}
                        </p>
                    </>
                    :
                    <>
                        <p className="text clinic" id={clinicsToolTipId} data-toggle="tooltip" data-html="true" data-original-title={clinicTooltip()} onMouseOver={() => onUserCardMouseOverClinic()}>
                            {hasRoleMA ? userInfo.clinicName : userInfo.organisationName}
                        </p>
                    </>
            }

        </div>
    )
}